import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockValuationReportModel } from './stock-valuation-report-model';

export class StockValuationResponseModel extends GlobalResponseObject {
    data?: StockValuationReportModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StockValuationReportModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}